import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { applyTheme, getCachedTheme } from './common/logic/Theme'
import './index.css'

// React 18 createRoot API with fallback for @types/react-dom@17 compatibility
const rootEl = document.getElementById('root')!;
const cachedTheme = getCachedTheme()
if (cachedTheme !== null) {
    applyTheme(cachedTheme)
}

(ReactDOM as any).createRoot(rootEl).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
